import React, { createContext, useContext } from 'react'
import useEvergreenMessagingFetch from './useEvergreenMessagingFetch'
import type { UseEvergreenMessagingReturn } from './types'

const EvergreenMessagingContext = createContext<
  UseEvergreenMessagingReturn | undefined
>(undefined)

function EvergreenMessagingProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const value = useEvergreenMessagingFetch()

  return (
    <EvergreenMessagingContext.Provider value={value}>
      {children}
    </EvergreenMessagingContext.Provider>
  )
}

export const useEvergreenMessaging =
  (): UseEvergreenMessagingReturn => {
    const context = useContext(EvergreenMessagingContext)
    if (!context) {
      throw new Error(
        'useEvergreenMessaging must be used within'
        + ' EvergreenMessagingProvider'
      )
    }
    return context
  }

export default EvergreenMessagingProvider
